import { twMerge } from "tailwind-merge"
// Using 'tailwind-override' to get rid of eventual duplicate tailwind classes
// This can happen if UI component is stylable and receives 'classNames' from props (ie. see <Collapsible />)
// The 'classNames' from props should have priority over the predefined component classes.
// See https://github.com/richardgill/tailwind-override for more info.

export const classNames = (...args) => twMerge(...args)
